export default [
    {title: "General.CarTypeOfFuel.DIESEL", value: "DIESEL"},
    {title: "General.CarTypeOfFuel.90", value: "90"},
    {title: "General.CarTypeOfFuel.92", value: "92"},
    {title: "General.CarTypeOfFuel.95", value: "95"},
    {title: "General.CarTypeOfFuel.80", value: "80"},
    {title: "General.CarTypeOfFuel.Gas", value: "Gas"}
]
